/* eslint-disable react/destructuring-assignment */ import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { OptimizationLegacy, Theme } from "@silvertours/front-legacy-shared";
import { useMedia } from "react-use";
import { SegmentImageContainer } from "./Segment.styles";
var isImageSegment = function(props) {
    return Object.prototype.hasOwnProperty.call(props, "image");
};
var SegmentImageBackground = function(props) {
    var isMobile = useMedia("(max-width: ".concat(Theme.getBreakpoint("lg"), "px)"), true);
    if (!isImageSegment(props) || props.isStage && isMobile && props.includeSearch) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SegmentImageContainer, {
        id: props.id,
        isStage: props.isStage,
        includeSearch: props.includeSearch,
        children: /*#__PURE__*/ _jsx(OptimizationLegacy.ResponsiveImage, _object_spread_props(_object_spread({}, props.image), {
            priority: true
        }))
    });
};
export { SegmentImageBackground };
